// extracted by mini-css-extract-plugin
module.exports = {"defaultSection":"defaultSection_defaultSection__1V2-b"};